import React from 'react';
import PropTypes from 'prop-types';

import { ASmartField } from '../../atoms';

export default function MSmartField({
	id,
	label,
	items,
	value,
	iconType,
	className,
	placeholder,
	required,
	error,
	onChange,
	onSelect,
	onClick,
}) {
	return (
		<div className="m-input-field m-smart-input-field">
			<label htmlFor={id}>
				{label}
			</label>
			<ASmartField
				id={id}
				value={value}
				items={items}
				placeholder={placeholder}
				className={className}
				required={required}
				error={error}
				onChange={onChange}
				onSelect={onSelect}
				onClick={onClick}
				iconType={iconType}
			/>
		</div>
	);
}

MSmartField.propTypes = {
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	value: PropTypes.oneOf(PropTypes.object, PropTypes.string),
	items: PropTypes.array,
	iconType: PropTypes.string,
	className: PropTypes.string,
	placeholder: PropTypes.string,
	required: PropTypes.bool,
	error: PropTypes.bool,
	onChange: PropTypes.func,
	onSelect: PropTypes.func,
	onClick: PropTypes.func,
};

MSmartField.defaultProps = {
	className: '',
	value: '',
	items: [],
	iconType: '',
	placeholder: '',
	error: false,
	required: false,
	onChange: undefined,
	onSelect: undefined,
	onClick: undefined,
};



// WEBPACK FOOTER //
// ./src/components/molecules/fields/_molecules.smart-field.js